import { jsx as _jsx } from "react/jsx-runtime";
import { CharacterProfile, ErrorScreen } from '@datapad/common-controls';
import { useAppContext } from '@datapad/data-model';
export function Profile(props) {
    const appContext = useAppContext();
    if (appContext.getEffectivePermissionLevel() === 'guest') {
        return (_jsx(ErrorScreen, { textLines: ['You must be logged in as a player to view your character profile.'] }));
    }
    return _jsx(CharacterProfile, { character: props.character, canEdit: true });
}
//# sourceMappingURL=Profile.js.map